import {createApp} from "vue";

import {registerPlugins} from "@core/utils/plugins";
import App from "@/App.vue";

// Styles
import "@core/scss/template/index.scss";
import "@styles/styles.scss";
import "vue3-toastify/dist/index.css";

import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

// Ensure Bugsnag is initialized
Bugsnag.start({
  apiKey: 'ab60078e36a43ea7a2bc7792d8d86f8c',
  plugins: [new BugsnagPluginVue()],
  autoTrackSessions: false,
  releaseStage: process.env.NODE_ENV,
  enabledReleaseStages: ['production', 'staging'],
  onError: function (event) {
    event.addMetadata('code', {
      type: "client",
    })
  }
});

const app = createApp(App);

const bugsnagVue = Bugsnag.getPlugin('vue');

if (bugsnagVue) {
  bugsnagVue.installVueErrorHandler(app);
}

// Create vue app

// Register plugins
registerPlugins(app);

// Mount vue app
app.mount("#app");
